import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Rect,
  Svg,
  Circle as _Circle
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M5.5 20H8", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M17 9h.01", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Rect, { width: "10", height: "16", x: "12", y: "4", rx: "2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M8 6H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(_Circle, { cx: "17", cy: "15", r: "1", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "MonitorSpeaker";
const MonitorSpeaker = memo(themed(Icon));
export {
  MonitorSpeaker
};
//# sourceMappingURL=monitor-speaker.js.map
